"use client";

// ===========================================
// konakla - İlan Detay Harita Wrapper
// ===========================================

import dynamic from "next/dynamic";
import { Loader2 } from "lucide-react";

// Dynamic import to avoid SSR issues with Leaflet
const LocationMap = dynamic(
  () => import("@/components/common/location-map").then((mod) => mod.LocationMap),
  {
    ssr: false,
    loading: () => (
      <div className="bg-muted flex h-full w-full items-center justify-center rounded-lg">
        <Loader2 className="text-muted-foreground h-8 w-8 animate-spin" />
      </div>
    ),
  }
);

interface ListingMapProps {
  latitude: number;
  longitude: number;
  title: string;
  className?: string;
}

export function ListingMap({ latitude, longitude, title, className = "h-64" }: ListingMapProps) {
  // Don't render if coordinates are invalid
  if (!latitude || !longitude || latitude === 0 || longitude === 0) {
    return (
      <div className={`${className} bg-muted flex items-center justify-center rounded-lg`}>
        <p className="text-muted-foreground text-sm">Harita bilgisi bulunamadı</p>
      </div>
    );
  }

  return (
    <div className={className}>
      <LocationMap
        latitude={latitude}
        longitude={longitude}
        title={title}
        className="h-full w-full"
        zoom={14}
        interactive={true}
        privacyRadiusMeters={300}
      />
    </div>
  );
}
